import { QueryClient } from '@tanstack/react-query';

/**
 * Generate consistent query keys
 */
export function createQueryKey(base: string, params?: Record<string, any>): (string | Record<string, any>)[] {
  return params ? [base, params] : [base];
}

/**
 * Standard invalidation patterns for related queries
 */
export function invalidateRelatedQueries(
  queryClient: QueryClient,
  keys: string[]
) {
  keys.forEach(key => queryClient.invalidateQueries({ queryKey: [key] }));
}

/**
 * Format Supabase errors into user-friendly messages
 */
export function formatSupabaseError(error: any): string {
  // Unique constraint violation
  if (error.code === '23505') {
    return 'A record with this information already exists';
  }
  
  // Foreign key violation
  if (error.code === '23503') {
    return 'Cannot delete - this record is referenced elsewhere';
  }
  
  // Not null violation
  if (error.code === '23502') {
    return 'Required field is missing';
  }
  
  // Use error message if available
  if (error.message) {
    return error.message;
  }
  
  return 'An unexpected error occurred';
}
